try {
	// Move jQuery to Global Scope
	// window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js').default;
    require('bootstrap');
} catch (e) {}

// window.axios = require('axios');
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// let token = document.head.querySelector('meta[name="csrf-token"]');
// if (token) {
//     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
//     console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
// }

// window.Vue = require('vue');

/**
 * App object
 * 
 * @version 2.0.0
 */
class App {
	constructor() {
		document.addEventListener('DOMContentLoaded', this.collect.bind(this));
	}
	add(propertyName, object) {
		this[propertyName] = object;
	}
	call(signature, element) {
		try {
			this.envoke(((signature) => {
				signature.shift();
				return signature;
			})(signature.split('.')))(element);
		} catch (error) {
			console.error(error);
		}
	}
	envoke(rest, current = this) {
		return rest.length == 1 ? current[rest.shift()].bind(current) : this.envoke(rest, current[rest.shift()]);
	}
	collect() {
		for (let element of document.querySelectorAll('[app-call]'))
			this.call(element.getAttribute('app-call'), element);
		console.log('App JS Loaded');
	}
}
window.app = new App();


// WEBPACK FOOTER //
// ./_src/js/app.js